import { render, staticRenderFns } from "./SingleGraph.vue?vue&type=template&id=1ffa61ac&scoped=true&lang=pug"
import script from "./SingleGraph.vue?vue&type=script&lang=js"
export * from "./SingleGraph.vue?vue&type=script&lang=js"
import style0 from "./SingleGraph.vue?vue&type=style&index=0&id=1ffa61ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffa61ac",
  null
  
)

export default component.exports